import { LoadingButton as MuiLoadingButton } from "@mui/lab";
import LoadingIndicator from "./LoadingIndicator";

const LoadingButton = ({ ...rest }) => {
	return <MuiLoadingButton loadingIndicator={<LoadingIndicator />} {...rest} />;
};

export default LoadingButton;
